import { ListItemText } from '@mui/material';
import Highlighter from 'react-highlight-words';
import SelectedListItemText from '../SelectedListItemText';
import { useSelector } from 'react-redux';

export default function SearchItemText({ isPageShowing, title, query, pageNumber, pageNumberText }) {
        const usePageNumbering = useSelector((state) => state.documentView.usePageNumbering);

    let pageTextDisplay = pageNumber.toString();
    if(!usePageNumbering && !!pageNumberText) {
        pageTextDisplay = pageNumberText;
    }

    const contents = (
        <>
            <span style={{fontWeight: 'bold'}}>Page {pageTextDisplay}</span>
            <br />
            <Highlighter
                searchWords={[query]}
                autoEscape={true}
                textToHighlight={title}
            />
        </>
    );

    return isPageShowing ? <SelectedListItemText>{contents}</SelectedListItemText> : <ListItemText>{contents}</ListItemText>;
}